import React from 'react';
import { ICoursePricing, IRequirements } from '../../../models/course/ICourseData';
import styles from './course-keyfacts.module.scss';
import Dinero from 'dinero.js';
import Markdown from 'markdown-to-jsx';
import Button from '../../atoms/button/button';
import { ButtonStyleType } from '../../../constants/button-style-type';
import { ICoursePageSettings } from '../../../models/course/ICoursePageSettings';

export type Props = {
  courseName?: string;
  coursePageSettings: ICoursePageSettings;
  courseInstanceRequirements: IRequirements;
  courseInstanceTuitionFee: ICoursePricing;
  courseInstancesStartDates: string[];
  keyInformationRichText: string;
  courseSynonym: string;
};

export default function CourseKeyFacts({
  courseName,
  coursePageSettings,
  courseInstanceRequirements,
  courseInstanceTuitionFee,
  courseInstancesStartDates,
  keyInformationRichText,
  courseSynonym,
}: Props) {
  const RemoveDecimals = (amount) => {
    if (amount === null) return 0;
    return amount.slice(0, -3);
  };

  const tuitionFeeDisplay = (tuitionFee: ICoursePricing): string => {
    return RemoveDecimals(
      Dinero({
        amount: tuitionFee.amount,
        currency: tuitionFee.currency ?? ``,
        precision: 0,
      }).toFormat(),
    );
  };

  return (
    <div className='row'>
      {/* <div className="col-xl-6">
        <h3 className={styles[`course-sub-title`]}>Key Facts</h3>
        <div className={`${styles["key-facts"]} mb-4`}>
          {!!courseInstanceRequirements?.academic && (
            <div className={styles["key-facts-item"]}>
              <p className={styles[`key-facts-header`]}>
                Academic Requirements
              </p>
              <div className={styles[`key-facts-description`]}>
                <Markdown>{courseInstanceRequirements.academic}</Markdown>
              </div>
            </div>
          )}
          {!!courseInstanceRequirements?.language && (
            <div className={styles["key-facts-item"]}>
              <p className={styles[`key-facts-header`]}>
                English Language Requirements
              </p>
              <div className={styles[`key-facts-description`]}>
                <Markdown>{courseInstanceRequirements.language}</Markdown>
              </div>
            </div>
          )}
          {!!courseInstancesStartDates && (
            <div className={styles["key-facts-item"]}>
              <p className={styles[`key-facts-header`]}>Start Dates</p>
              {courseInstancesStartDates?.map((startDate) => (
                <p key={startDate} className={styles[`key-facts-description`]}>
                  {startDate}
                </p>
              ))}
            </div>
          )}
          <div className={styles["key-facts-item"]}>
            <p className={styles[`key-facts-header`]}>Tuition Fee</p>
            <div className={styles[`key-facts-description`]}>
              {courseInstanceTuitionFee ? (
                <>
                  From: <b>{tuitionFeeDisplay(courseInstanceTuitionFee)}</b>
                </>
              ) : (
                <p>
                  Pricing for this {courseSynonym} is currently unavailable.
                </p>
              )}
            </div>
          </div>
        </div>
        <Button
          buttonStyle={ButtonStyleType.Filled}
          buttonNewTab="_blank"
          buttonURL={coursePageSettings.applyURL}
          buttonRole="link"
          buttonSize={coursePageSettings.buttonSize}
          copyColor={coursePageSettings.buttonCopyColor}
          backgroundColor={coursePageSettings.backgroundColor}
          hoverBackgroundColor={coursePageSettings.hoverBackgroundColor}
          activeBackgroundColor={coursePageSettings.activeBackgroundColor}
          buttonAriaLabel={courseName}
          heapIdentifier={"new-course-page-apply"}
        >
          Apply
        </Button>
      </div> */}

      <div className='col-md-12'>
        {keyInformationRichText?.length ? (
          <>
            <h3 id="course-key-information" className={styles[`course-sub-title`]}>Key Information</h3>
            <section className={styles[`course-key-information`]}>
              <Markdown>{keyInformationRichText}</Markdown>
            </section>
          </>
        ) : null}
      </div>
    </div>
  );
}
